// /app/frontend/src/api/analytics.js
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;

/**
 * Track an analytics event.
 * Fire-and-forget; never throws.
 * @param {string} event - Event name (e.g., "seo_header_cta_click")
 * @param {object} props - Optional properties
 */
export async function trackEvent(event, props = {}) {
  try {
    const token = localStorage.getItem("token");

    // POST /api/analytics/track  (auth optional)
    fetch(`${BACKEND_URL}/api/analytics/track`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify({ event_name: event, props }),
    }).catch(() => {}); // Silent fail

  } catch {
    // no-op: analytics must never break UX
  }
}
